<script setup>
import SkeletonPlaceholder from '@/components/Base/SkeletonPlaceholder.vue'

const props = defineProps({
    sidebarMainHeadlineConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator: (rawValue) => {
            const validations = {
                title: value => value === undefined || typeof value === 'string',
                placeholder: value => value === undefined || typeof value === 'boolean'
            }

            return Object.entries(validations).every(([key, validation]) => validation(rawValue[key]))
        }
    }
})

const { $md } = useNuxtApp()
const getTitle = computed(() => $md.renderInline(props.sidebarMainHeadlineConfig?.title || ''))
</script>

<template>
    <component
        :is="SkeletonPlaceholder"
        v-if="sidebarMainHeadlineConfig.placeholder"
        :skeleton-placeholder-config="{
            type: 'multi-headline',
            tag: 'h2'
        }"
    />

    <h2 v-else-if="sidebarMainHeadlineConfig.title" class="sidebar-main-headline" v-html="getTitle" />
</template>

<style lang="scss">
.sidebar-main-headline {
    text-align: center;
    display: inline-block;

    @include superheadline-h1($margin: 0 0 px2rem(40));

    @include bp(medium1) {
        font-family: $font-body;
        font-weight: 800;
        font-size: px2rem(20);
        line-height: px2rem(25);
        padding-inline: 0;
        letter-spacing: 0;
        display: block;
        width: 100%;
    }

    &::before {
        @include bp(medium1) {
            display: none;
        }
    }

    br {
        display: none;
    }

    em {
        display: block;

        @include bp(medium1) {
            font-family: $font-body;
            font-weight: 800;
            font-size: px2rem(20);
            line-height: px2rem(25);
            font-style: normal;
            display: inline;
        }
    }
}
</style>
